<!--header-right-->
<template>
  <div class="home-business-card">
    <hs-tab-2 v-if="tabList.filter(v => v).length >= 2" height="42px" @select="_selectTab" type="homePlaneAndHotel" :selectedIndex="selectedIndex" :options="tabList" />
    <hs-tab-2 v-else height="42px" type="homePlaneAndHotel" :selectedIndex="0" :options="tabList.filter(v => v).concat([''])" />
    <!--  机票 start  -->
    <div class="home-business-card-content" v-if="tabList[selectedIndex] === $t('FlightTicket')">
      <hs-tab-4 style="margin-bottom: 8px" type="card" :selectedIndex="planeSelectIndex" :options="planeOptions" height="32px" @select="mixinPlaneTabSelect" />

      <div>
        <!-- 单程往返 -->
        <template v-if="!isPlaneMultiPass">
          <!-- 出发到达 -->
          <home-business-card-city
              :title1="mixinPlaneGetCityName(SelectedFlights[0] && SelectedFlights[0].DepartObject)"
              :placeholder1="$t('DepartureCity')"
              :title2="mixinPlaneGetCityName(SelectedFlights[0] && SelectedFlights[0].ArrivalObject)"
              :placeholder2="$t('ArrivalCity')"
              @clickLeft="mixinPlaneClickDeparture"
              @clickRight="mixinPlaneClickArrive"
              @switch="mixinPlaneSwitchCity"
          />
          <!-- 日期 -->
          <home-business-card-city
              busType="date"
              :title1="planeDatePickerDate"
              :title2="planeDatePickerEndDate"
              :placeholder1="$t('DepartureDate')"
              :placeholder2="planeOptions[planeSelectIndex] === $t('RoundTrip') ? $t('ReturnDate') : ''"
              @clickLeft="mixinPlaneClickDate(0, true)"
              @clickRight="mixinPlaneClickDate(0, false)"
          />
        </template>

        <!-- 多程 -->
        <template v-else>
          <div class="multi-pass-plane"
               v-for="(item, index) in mulSelectedFlights"
               :key="`multiPassPlane${index}`"
               :type="index === mulSelectedFlights.length - 1 && mulSelectedFlights.length < 6 ? 'last' : ''"
          >
            <!-- 出发到达 -->
            <home-business-card-city
                :index="index"
                :title1="mixinPlaneGetCityName(item.DepartObject)"
                :placeholder1="$t('DepartureCity')"
                :title2="mixinPlaneGetCityName(item.ArrivalObject)"
                :placeholder2="$t('ArrivalCity')"
                @clickLeft="mixinPlaneClickDeparture(index)"
                @clickRight="mixinPlaneClickArrive(index)"
                @switch="mixinPlaneSwitchCity(index)"
            />
            <!-- 日期 -->
            <home-business-card-city
                style="padding-left: 20px"
                busType="date"
                :title1="item.DepartDate"
                :placeholder1="$t('DepartureDate')"
                :clearable="mulSelectedFlights.length > 2"
                :segmentType="2"
                @clickLeft="mixinPlaneClickDate(index, true)"
                @clickRight="mixinPlaneClickDate(index, false)"
                @clear="mixinPlaneClearSegment(index)"
            />
          </div>

          <!-- 新增 -->
          <home-business-card-add v-if="mulSelectedFlights && mulSelectedFlights.length < 6" @click.native="mixinPlaneAddSegment" />
        </template>

        <!--选择乘机人-->
        <home-business-cell
            :title="PassengerNames"
            :showLogo="true"
            :logoName="Passengers && Passengers.length > 0 ? 'icons_24pt_close.svg' : 'icons_12pt_right.png'"
            @clickLeft="$refs.RefsCPassenger && $refs.RefsCPassenger.open()"
            @right="Passengers && Passengers.length > 0 ? mixinDelegatePlaneWithConfirm([]) : ($refs.RefsCPassenger && $refs.RefsCPassenger.open())"
        />

        <!-- 舱位 -->
        <home-business-card-city
            :title1="FlightClassText"
            fontType="middle"
            :placeholder1="$t('PleaseChoosesCabinLevel')"
            @clickLeft="mixinPlaneSelectCabins"
        >
          <span v-if="!Passengers || Passengers.length <= 0" slot="right-icon" key="planeAdult" @click.stop="mixinPlaneAdultClick" class="room-amount">
            {{GetPeopleDes(PlaneAdultAmount, PlaneChildAmount, PlaneInfantAmount)}}
          </span>
        </home-business-card-city>
      </div>

      <hs-button
          :style="{background: getTheme('home:c-tabbar:active-color')}"
          class="btn"
          width="100%"
          height="46px"
          :fontSize="null"
          type="theme"
          @click="mixinPlaneGoQuery"
      >{{$t('SearchFlight')}}</hs-button>

      <!-- 多程不做快捷历史 -->
      <history-trip
          v-if="!isPlaneMultiPass"
          type="new-style"
          style="margin-top: 12px"
          storageKey="HISTORY_TRIP_PLANE_CITY"
          :hasInterPlanePower="(Number(TravelType) === 0 && hasPower('因公:机票:国际机票查询')) || (Number(TravelType) === 1 && hasPower('因私:国际机票'))"
          ref="RefsHistoryTrip"
          @select="mixinPlaneHistoryTripSelect"
      />
      <div v-if="!$refs.RefsHistoryTrip || ($refs.RefsHistoryTrip && $refs.RefsHistoryTrip.list.length <= 0)" style="height: 4px"></div>
    </div>
    <!--  机票 end  -->

    <!--  酒店 start  -->
    <div class="home-business-card-content" style="padding-bottom: 16px" v-else-if="tabList[selectedIndex] === $t('Hotel')">
      <hs-tab-4
          v-if="hasHotelAndIntlHotel"
          style="margin-bottom: 8px"
          type="card"
          :selectedIndex="hotelTabActiveIndex"
          :options="hotelOptions"
          height="32px"
          @select="mixinHotelTabSelect"
      />
      <div>
        <!-- 出发到达 -->
        <home-business-card-city
            :title1="hotelCityName"
            :subTitle1="isInterHotel ? getCountryName(iHotelOrder.City) : ''"
            :placeholder1="!isInterHotel ? $t('China_1') : $t('IntlDestination')"
            :showRightIcon="!isInterHotel"
            @clickLeft="mixinHotelClickDeparture"
            @clickRightIcon="mixinHotelLocation"
        />
        <!-- 日期 -->
        <home-business-card-city
            busType="date"
            :title1="checkInDate"
            :title2="checkOutDate"
            :orderBusinessType="2"
            :YesterdayCloseHours="YesterdayCloseHours"
            :placeholder1="$t('DepartureDate')"
            :placeholder2="$t('ReturnDate')"
            @clickLeft="mixinHotelClickDate"
            @clickRight="mixinHotelClickDate"
        />
        <div v-if="mixinHotelIsBeforeDawn()" class="tips"><span>{{$t('HotelPromptIsMorning')}}</span></div>
        <!-- 关键字、位置、品牌、酒店名 -->
        <home-business-card-city
            :title1="HotelBusinessDistrictBrand"
            fontType="middle"
            :placeholder1="$t('KeywordSearch_1')"
            clearable
            @clear="mixinHotelClearFilterDetails"
            @clickLeft="mixinHotelClickFilterDetails"
        />
        <!-- 价格星级 -->
        <home-business-card-city
            style="box-shadow: none"
            :title1="hotelPriceAndStarText"
            fontType="middle"
            :placeholder1="isInterHotel ? $t('PriceRating_1') : $t('PriceRating')"
            clearable
            @clear="mixinHotelPriceAndStar"
            @clickLeft="showHotelStarAndPrice = true"
        >
        <span
            slot="right-icon"
            key="hotel"
            @click.stop="mixinHotelRoomAdultClick"
            class="room-amount">{{getRoomDes(RoomAmount, AdultAmount, ChildAmount)}}</span>
        </home-business-card-city>
      </div>

      <hs-button
          :style="{background: getTheme('home:c-tabbar:active-color')}"
          class="btn"
          width="100%"
          height="46px"
          :fontSize="null"
          type="theme"
          @click="mixinHotelGoQuery"
      >{{$t('SearchHotel')}}</hs-button>
    </div>
    <!--  酒店 end  -->

    <!--  机票 地址选择器  -->
    <hs-teleport to="body">
      <hs-address-picker
          v-model="showPlaneAddressPicker"
          :switchList="addressPickerOptions"
          :title="whichSegments.from ? $t('DepartureCity') : $t('ArrivalCity')"
          :showSwitchBar="addressPickerOptions && addressPickerOptions.length > 1"
          :activeIndex.sync="tabActiveIndex"
          @select="mixinPlaneSetAddress"
      ></hs-address-picker>
    </hs-teleport>

    <!--  机票日期选择器  -->
    <hs-teleport to="body">
      <hs-date-picker
          v-model="showPlaneDatePicker"
          :date="planeDatePickerDate"
          :endDate="planeDatePickerEndDate"
          :isRangePicker="planeOptions[planeSelectIndex] === $t('RoundTrip')"
          :currentTrip="isPlaneMultiPass ? mulSelectedFlights[whichSegments.index] : SelectedFlights[whichSegments.index]"
          :OrderBusinessType="isIntlPlane ? 6 : 1"
          :overdueDate="planeOverdueDate"
          :maxToDataDays="null"
          @changeDate="mixinPlaneSetDate"
      >
      </hs-date-picker>
    </hs-teleport>

    <!-- 酒店地址选择器 -->
    <hs-teleport to="body">
      <!-- 地址选择器 -->
      <hs-address-picker
          ref="RefsHotelAddressPicker"
          v-model="showHotelAddressPicker"
          :OrderBusinessType="isInterHotel ? 11 : 2"
          :switchList="hotelOptions"
          :activeIndex.sync="hotelTabActiveIndex"
          :title="$t('SelectCity')"
          :defaultMultipleCities="isInterHotel && iHotelOrder.CityID ? [iHotelOrder.City] : []"
          @select="mixinHotelSetCity"
          @delegateWithLngWithLatWithAddress="mixinHotelSetAddressWidthLngLat"
      ></hs-address-picker>
    </hs-teleport>

    <!-- 酒店日期选择器 -->
    <hs-teleport to="body">
      <!-- 日期选择器 -->
      <hs-date-picker-2
          :show.sync="showHotelDatePicker"
          :overdueDate="hotelOverdueDate"
          :maxDate="null"
          :fromDate="checkInDate"
          :YesterdayCloseHours="YesterdayCloseHours"
          :tips="isInterHotel ? $t('PromptDateHotel') : ''"
          @update:fromDate="mixinHotelSetFromDate"
          :toDate="checkOutDate"
          @update:toDate="mixinHotelSetToDate"
      ></hs-date-picker-2>
    </hs-teleport>

    <!-- 酒店商圈 -->
    <hs-teleport to="body">
      <c-hotel-filter-home
          :dHotelOrder="isInterHotel ? iHotelOrder : dHotelOrder"
          :IsOaSearch="false"
          :show.sync="showHotelFilter"
          :searchText="isInterHotel ? interQueryText : QueryText"
          :OrderBusinessType="isInterHotel ? 11 : 2"
          @updateFilterDetails="mixinHotelSetFilterDetails"
      />
    </hs-teleport>

    <!-- 酒店价格星级 -->
    <hs-teleport to="body">
      <c-hotel-price-star
          :show.sync="showHotelStarAndPrice"
          :HighRate="isInterHotel ? iHotelOrder.HighRate : dHotelOrder.HighRate"
          :LowRate="isInterHotel ? iHotelOrder.LowRate : dHotelOrder.LowRate"
          :StarRate="isInterHotel ? iHotelOrder.StarRate : dHotelOrder.StarRate"
          :OrderBusinessType="isInterHotel ? 11 : 2"
          :isInterHotel="isInterHotel"
          @delegate="mixinHotelSetPriceAndStar"
      />
    </hs-teleport>

    <!-- 海外酒店入住规则 -->
    <hs-teleport to="body">
      <c-check-room
          :show.sync="showCCheckRoom"
          :RoomAmount="RoomAmount"
          :AdultAmount="AdultAmount"
          :ChildAmount="ChildAmount"
          :ages="ChildAges"
          @delegate="mixinCheckRoomCallback"
      />
    </hs-teleport>

    <!--仓位选择-->
    <hs-teleport to="body">
      <c-picker-1 :show.sync="showFlightClass" :title="$t('CabinLevel')" :data="FlightClassLimits" :selected="FlightClassValue" @selected="mixinPlaneSetCabins" />
    </hs-teleport>

    <!--机票选择人数-->
    <hs-teleport to="body">
      <c-select-people-count
          :show.sync="showSelectPeopleCount"
          :showCarryChildInfant="showCarryChildInfant"
          :AdultAmount="PlaneAdultAmount"
          :ChildAmount="PlaneChildAmount"
          :InfantAmount="PlaneInfantAmount"
          @delegate="mixinPlaneSelectPeopleCountCallback"
      />
    </hs-teleport>

    <!-- 儿童婴儿描述 -->
    <hs-teleport to="body">
      <c-frame-alert
          ref="CFrameAlert"
          :title="$t('ChildrenAndBabyExplain')"
          :url="domainNameReplace('https://h5comm.homsom.com/static/html/childAndBaby.html')"
      />
    </hs-teleport>

    <hs-teleport to="body">
      <c-passenger-list
          ref="RefsCPassenger"
          :XOrder="{...XOrder, TravelType}"
          :OrderBusinessType="OrderBusinessType"
          :MaxLength="OrderBusinessType === 11 || OrderBusinessType === 2 ? 20 : 9"
          :animationName="OrderBusinessType === 11 || OrderBusinessType === 2 ? 'slide-left' : ''"
          :requiredPassengers="true"
          @delegateWithConfirm="_delegateWithConfirm"
      />
    </hs-teleport>
  </div>
</template>
<script type="text/ecmascript-6">
import HsButton from "@/base/hs-button/hs-button.vue";
import HsTab2 from "@/base/hs-tab/hs-tab-2.vue";
import HsTab4 from "@/base/hs-tab/hs-tab-4.vue";
import HomeBusinessCardCity from "@/pages/home/home/home-business-card-city.vue";
import HomeBusinessCell from "@/pages/home/home/home-business-cell.vue";
import HistoryTrip from "@/components/history-trip/history-trip.vue";
import HomeBusinessCardAdd from "@/pages/home/home/home-business-card-add.vue";
import HsTeleport from "@/base/hs-teleport/hs-teleport.vue";
import HsAddressPicker from "@/base/hs-address-picker/hs-address-picker.vue";
import HsDatePicker from "@/base/hs-date-picker/hs-date-picker.vue";
import HsDatePicker2 from "@/base/hs-date-picker/hs-date-picker-2.vue";
import HsNation from "@/base/hs-nation/hs-nation.vue";
import CHotelPriceStar from "@/components/c-filter/c-hotel-price-star.vue";
import CheckRoom from "@/pages/hotel/query/check-room.vue";
import CFrameAlert from "@/components/c-frame/c-frame-alert.vue";
import CPassengerList from "@/components/c-passenger/c-passenger-list.vue";
import HomeBusinessCardIntlGuest from "@/pages/home/home/home-business-card-intl-guest.vue";
import {mapState} from "vuex"

import MixinHomeBusinessCardPlane from "@/pages/home/home/mixin-home-business-card-plane";
import MixinHomeBusinessCardHotel from "@/pages/home/home/mixin-home-business-card-hotel";
import CPassenger from "@/components/c-passenger/c-passenger.vue";
import CCheckRoom from "@/components/c-check-room/c-check-room.vue";
import {getRoomDes} from "@/components/c-check-room/c-check-room";
import CHotelFilterHome from "@/components/c-filter/c-hotel-filter/c-hotel-filter-home.vue";
import {GetPeopleDes} from "@/pages/home/home/plane-query";
import CPicker1 from "@/components/c-picker/c-picker-1.vue";
import CSelectPeopleCount from "@/components/c-check-room/c-select-people-count.vue";
export default {
  props: {
    TravelType: { // 0 因公 1 因私
      type: Number,
      default: 0
    },
    subtitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedIndex: 0,
      IsCarryChild: false,
      IsCarryInfant: false,
      tabList: [this.$t('FlightTicket'), this.$t('Hotel')]
    }
  },
  mixins: [MixinHomeBusinessCardPlane, MixinHomeBusinessCardHotel],
  computed: {
    ...mapState([
      'PersonalPower',
    ]),
    OrderBusinessType() {
      let OrderBusinessType = 1
      if (this.tabList[this.selectedIndex] === this.$t('FlightTicket')) {
        OrderBusinessType = this.isIntlPlane ? 6 : 1
      } else if (this.tabList[this.selectedIndex] === this.$t('Hotel')) {
        OrderBusinessType = this.isInterHotel ? 11 : 2
      }
      return OrderBusinessType
    },
    XOrder() {
      let XOrder = this.dFlightOrder
      if (this.OrderBusinessType === 6) {
        XOrder = this.iFlightOrder
      } else if (this.OrderBusinessType === 2) {
        XOrder = this.dHotelOrder
      } else if (this.OrderBusinessType === 11) {
        XOrder = this.iHotelOrder
      }
      return XOrder
    }
  },
  mounted() {
    this._componentsInitInfo()

    this.mixinGetFlightInitWithAjax() // 初始化国内机票舱位信息
    this.mixinGetIntlFlightInitWithAjax() // 初始化国际机票舱位信息
    this.mixinPlaneGetLocalStorageWithQuery() // 机票获取行程缓存

    // 初始化酒店信息
    this.mixinHotelInitInfo(2)
    this.mixinHotelInitInfo(11)
    this.mixinHotelGetDateStorage() // 获取酒店日期缓存
    this.mixinHotelGetCityStorage() // 获取酒店城市缓存
  },
  watch: {
    PersonalPower() {
      // 初始化机票权限
      this._componentsInitInfo()
      this.mixinPlaneGetLocalStorageWithQuery() // 机票获取行程缓存
      this.mixinHotelGetDateStorage() // 获取酒店日期缓存
    },
    TravelType() {
      this._componentsInitInfo()
      this.mixinReSetFlightClassWithTravelType() // 国内机票因公因私切换 重置舱等信息
    },
    HotelYesterdayCloseHours() {
      this.mixinHotelInitInfo(2)
    },
    IntlHotelYesterdayCloseHours() {
      this.mixinHotelInitInfo(11)
    }
  },
  methods: {
    GetPeopleDes,
    getRoomDes,
    // 组件初始化相关数据
    _componentsInitInfo() {
      this.mixinPlaneInitPersonalPower() // 初始化机票权限
      this.mixinHotelInitPersonalPower() // 初始化酒店权限
      this._initTabList() // 初始化机票酒店tab栏
    },

    // 初始化机票酒店tabList
    _initTabList() {
      this.tabList = []
      if (this.TravelType === 0) { // 因公
        let busPlane = this.hasPower('因公:机票:国内机票查询') || this.hasPower('因公:机票:国际机票查询')
        let busHotel = this.hasPower('因公:酒店:国内酒店查询') || this.hasPower('因公:酒店:国际酒店查询')
        if (busPlane) {
          this.tabList.push(this.$t('FlightTicket'));
        } else {
          this.tabList.push('');
        }
        if (busHotel) {
          this.tabList.push(this.$t('Hotel'))
        } else {
          this.tabList.push('')
        }
        !this.tabList[this.selectedIndex] && (this.selectedIndex = this.tabList.findIndex(v => v !==''))
      } else {
        let perPlane = this.hasPower('因私:国内机票') || this.hasPower('因私:国际机票')
        let perHotel = this.hasPower('因私:国内酒店') || this.hasPower('因私:国际酒店')
        if (perPlane) {
          this.tabList.push(this.$t('FlightTicket'))
        } else {
          this.tabList.push('')
        }
        if (perHotel) {
          this.tabList.push(this.$t('Hotel'))
        } else {
          this.tabList.push('')
        }
        !this.tabList[this.selectedIndex] && (this.selectedIndex = this.tabList.findIndex(v => v !==''))
      }
    },
    _selectTab(val) {
      this.selectedIndex = val
    },

    // 先选人回调
    _delegateWithConfirm(Passengers, RoomAmount, AdultAmount, ChildAmount, ChildAges) {
      // 国内国际机票
      if (this.OrderBusinessType === 1 || this.OrderBusinessType === 6) {
        this.mixinDelegatePlaneWithConfirm(Passengers)
      } else if (this.OrderBusinessType === 2) { // 国内酒店
        this.dHotelOrder.RoomAmount = RoomAmount
        this.dHotelOrder.AdultAmount = AdultAmount
        this.dHotelOrder.ChildAmount = ChildAmount
        this.dHotelOrder.ChildAges = ChildAges
        this.mixinSelectGuests(Passengers)
      } else if (this.OrderBusinessType === 11) { // 海外酒店
        this.iHotelOrder.RoomAmount = RoomAmount
        this.iHotelOrder.AdultAmount = AdultAmount
        this.iHotelOrder.ChildAmount = ChildAmount
        this.iHotelOrder.ChildAges = ChildAges
        this.mixinSelectIntlGuests(Passengers)
      }
    },
  },
  components: {
    CSelectPeopleCount,
    CPicker1,
    CHotelFilterHome,
    CCheckRoom,
    CPassenger,
    HsTab2,
    HsTab4,
    HomeBusinessCardCity,
    HomeBusinessCell,
    HomeBusinessCardAdd,
    HsNation,
    CHotelPriceStar,
    CheckRoom,
    HistoryTrip,
    HsTeleport,
    HsAddressPicker,
    HsDatePicker,
    HsDatePicker2,
    CFrameAlert,
    CPassengerList,
    HomeBusinessCardIntlGuest,
    HsButton
  },
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
/** 超标支付样式  */
.home-business-card
  width 100%
  border-radius 12px
  background-color $color_black_0
  box-shadow 0 4px 8px 0 rgba(44, 3, 3, 0.02)
  margin-bottom 12px
  .room-amount
    @extend .hs-font-body
    flex-shrink 0
    color $color_black_900
    margin-left 12px
    min-width 100px
    text-align right
  >.home-business-card-content
    padding 8px 16px 12px 16px
    >div
      >.multi-pass-plane
        box-shadow 0px -0.5px 0px 0px $color_black_30 inset
        &[type='last']
          box-shadow none
    .tips{
      @extend .flex-start;
      @extend .hs-font-overline-1;
      color: $color_yellow_300;
      padding: 4px 0;
      &::before {
        display: flex;
        flex-shrink: 0;
        content: ' ';
        width: 16px;
        height: 16px;
        margin-right: 4px;
        background: url(@/assets/image/base/warning/icons_16pt_remind.png) no-repeat;
        background-size: 100% 100%;
        align-self: baseline;
      }
    }
    >.btn
      background-size 100% auto
      background-repeat no-repeat
</style>
